import { Box, Skeleton, Stack, Typography } from '@mui/material';

import { BackupScopesResources } from '@/app/(dashboard)/settings/backup-policies/backup-scopes/[tab]/backupScopesResources';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@/components/accordion';
import {
  getResourcesScopeType,
  type ResourcesScopeType,
} from '@/components/resourcesSelection/resourceSelectionDynamicViewer';
import { useDAL } from '@/contexts/useDAL';

export const DiscoveryConfigurationAccordion = () => {
  const dal = useDAL();
  const { data: backupScope, isLoading } = dal.inventory.backupScope.useList();

  const resourcesScopeType: ResourcesScopeType = getResourcesScopeType(
    backupScope?.condition,
    'allIncluded'
  );

  const displayName =
    resourcesScopeType === 'allIncluded'
      ? 'All resources are included'
      : resourcesScopeType === 'allExcluded'
        ? 'All resources are excluded'
        : 'Custom configuration';

  return (
    <Box paddingX='min(100px,6vw)' width='100%' height='auto'>
      <Accordion>
        <AccordionSummary>
          <Stack
            width='100%'
            direction='row'
            alignItems='center'
            justifyContent='space-between'
          >
            <Typography>Discovery configuration</Typography>
            <span className='more-info'>
              {isLoading ? (
                <Skeleton variant='text' width='150px' height='40px' />
              ) : (
                <Typography variant='body1' className='font-semibold'>
                  {displayName}
                </Typography>
              )}
            </span>
          </Stack>
        </AccordionSummary>
        <AccordionDetails sx={{ paddingX: 0 }}>
          <Stack>
            <Typography marginLeft='40px' width='540px' variant='body1'>
              Define the resources you want Eon to discover, ensuring your
              backup is efficient and tailored to your needs. This setting will
              setting will be used for all source accounts you connect.
            </Typography>
            <BackupScopesResources panelType='bottom' />
          </Stack>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
